export class JobItemsDto{
    poNumber:number;

    shortCode:string;

    packStyle:string;

    jobCartons:number;

    jobLoosePouches:number;

     constructor(
        poNumber:number,
        shortCode:string,
        packStyle:string,
        jobCartons:number,
        jobLoosePouches:number
     ){
        this.poNumber=poNumber;
        this.shortCode=shortCode;
        this.packStyle=packStyle;
        this.jobCartons=jobCartons;
        this.jobLoosePouches=jobLoosePouches;
     }

}   